import {
  BundleBalance
} from 'helpers/models';

export const mapBundleBalance = (result) => {
  return new BundleBalance(result).mapToStandard();
};